import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Card, CardBody, Col, Form, FormGroup, Row } from "reactstrap";

import generalApi from "@/services/general-api";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { getErrorMessage } from "utilities/error";
import * as yup from "yup";
import { TitleContainer } from "@/components/HeaderContainer";
import { LightThemedButton, ThemedButton } from "@/components/ThemedButton";
import { Container } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

const schema = yup.object({
	reasonType: yup.string().required(),
	reason: yup.string().when("reasonType", {
		is: (reasonType) => reasonType == "Others",
		then: () => yup.string(),
		otherwise: () => yup.string().required(),
	}),
	remark: yup.string().when("reasonType", {
		is: (reasonType) => reasonType == "Others",
		then: () => yup.string().required("Please Enter a reason for withdrawal."),
		otherwise: () => yup.string(),
	}),
	supportingDocument: yup.mixed().required(),
});

function ModalWithdrawal() {
	const [loading, setLoading] = useState(false);
	const [message, setmessage] = useState("");
	const [withdrawalReason, setWithdrawalReason] = useState({});
	const [selectedReasonType, setSelectedReasonType] = useState("");
	const [selectedReason, setSelectedReason] = useState("");
	const selectedReasonRef = useRef();
	selectedReasonRef.current = selectedReason;

	let navigate = useNavigate();

	const location = useLocation();
	const { learner_id } = location.state || {};

	const courserunDetailQuery = useQuery({
		queryKey: ["courserun-details", learner_id],
		queryFn: () => generalApi.getUpcomingCourseById(learner_id),
	});

	const courserunData = courserunDetailQuery.data;
	const course = courserunData?.course;

	const {
		setValue,
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
	});

	useEffect(() => {
		generalApi.getWithdrawalReason().then(
			(response) => {
				setWithdrawalReason(response);
				// setSelectedReasonType(Object.keys(response)[0]);
			},
			(error) => {
				toast.error(getErrorMessage(error));
			},
		);
	}, []);

	useEffect(() => {
		setSelectedReason("");
		setValue("reason", "");
		// if (selectedReasonType === "Others") {
		// 	setSelectedReason("");
		// } else if (selectedReasonType) {
		// 	setSelectedReason(withdrawalReason[selectedReasonType][0]);
		// }
	}, [selectedReasonType]);

	const handleReasonTypeChange = (event) => {
		const reasonType = event.target.value;
		setSelectedReasonType(reasonType);
	};

	const handleReasonChange = (event) => {
		const reason = event.target.value;
		setSelectedReason(reason);
	};

	const handleWithdrawal = (data) => {
		setLoading(true);
		const formData = new FormData();

		formData.append("learner_id", learner_id);
		formData.append("reason_type", data.reasonType);
		formData.append("reason", data.reason);
		formData.append("remark", data.remark);
		console.log();
		if (data.supportingDocument.length < 1) {
			toast.error("Please Upload at least 1 Supporting Document.");
			setLoading(false);
		} else {
			for (let i = 0; i < data.supportingDocument.length; i++) {
				formData.append("attachment" + (i + 1), data.supportingDocument[i]);
			}

			generalApi
				.withdrawalCourse(formData)
				.then(
					() => {
						if (window.ReactNativeWebView) {
							window.ReactNativeWebView.postMessage(
								JSON.stringify({
									status: "success",
								}),
							);
						} else {
							setLoading(false);
							navigate("/course/success-page", {
								state: { data: { course: course, type: "withdrawal" } },
							});
						}
					},
					(error) => {
						setLoading(false);
						setmessage(getErrorMessage(error));
					},
				)
				.catch(() => {
					setLoading(false);
				});
		}
	};

	if (!course || !courserunData) return null;

	return (
		<Container>
			<TitleContainer>Withdrawal</TitleContainer>
			<div>
				<Card className='mt-2'>
					<CardBody>
						<p className='pb-2 text-fca-blue fs20 font_2'>{courserunData?.course_title}</p>

						<Form role='form' onSubmit={handleSubmit(handleWithdrawal)}>
							<Row>
								<Col md='6' xl='6'>
									<FormGroup>
										<label
											className='fs14 text-fca-dark font-weight-600'
											htmlFor='input-courseDate'>
											Course Date
										</label>
										<input
											className={"form-control " + (errors.courseDate ? "is-invalid" : "")}
											id='input-courseDate'
											disabled
											defaultValue={
												moment(course.courserun_course_from).format("DD MMM YYYY, ddd") +
												" - " +
												moment(course.courserun_course_to).format("DD MMM YYYY, ddd") +
												" (" +
												courserunData.venue_bulding +
												")"
											}></input>
									</FormGroup>
								</Col>

								<Col md='6' xl='6'>
									<FormGroup>
										<label
											className='fs14 text-fca-dark font-weight-600'
											htmlFor='input-courseTrainer'>
											Trainer
										</label>
										<input
											className={"form-control " + (errors.courseTrainer ? "is-invalid" : "")}
											id='input-courseTrainer'
											disabled
											defaultValue={course.trainer?.trainer_name}></input>
									</FormGroup>
								</Col>

								<Col md='6' xl='6'>
									<FormGroup>
										<label
											className='fs14 text-fca-dark font-weight-600'
											htmlFor='input-reasonType'>
											Reason Type
										</label>
										<select
											className={"form-control " + (errors.reasonType ? "is-invalid" : "")}
											{...register("reasonType")}
											id='input-reasonType'
											onChange={handleReasonTypeChange}
											// defaultValue={Object.keys(withdrawalReason)[0]}
										>
											<option value=''>Please Select Reason Type</option>
											{Object.keys(withdrawalReason).length !== 0
												? Object.keys(withdrawalReason).map((option, i) => (
														<option key={i} value={option}>
															{option}
														</option>
												  ))
												: ""}
										</select>
										<div className='invalid-feedback'>{errors.reasonType?.message}</div>
									</FormGroup>
								</Col>
								<Col md='6' xl='6'>
									{selectedReasonType && selectedReasonType !== "Others" ? (
										<FormGroup>
											<label className='fs14 text-fca-dark font-weight-600' htmlFor='input-reason'>
												Reason
											</label>

											<select
												className={"form-control " + (errors.reason ? "is-invalid" : "")}
												{...register("reason")}
												id='input-reason'
												value={selectedReasonRef.current}
												onChange={handleReasonChange}>
												<option value=''>Please Select Reason</option>
												{withdrawalReason[selectedReasonType].map((option, i) => (
													<option key={i} value={option}>
														{option}
													</option>
												))}
											</select>

											<div className='invalid-feedback'>{errors.reason?.message}</div>
										</FormGroup>
									) : (
										""
									)}
								</Col>
								<Col md='12' xl='12'>
									<FormGroup>
										<label className='fs14 text-fca-dark font-weight-600' htmlFor='input-remark'>
											Remark
										</label>
										<textarea
											className={"form-control " + (errors.remark ? "is-invalid" : "")}
											id='input-remark'
											placeholder='Enter your Remark here...'
											{...register("remark")}
										/>
										<div className='invalid-feedback'>{errors.remark?.message}</div>
									</FormGroup>
								</Col>
								<Col md='12' xl='12'>
									<FormGroup>
										<label
											className='fs14 text-fca-dark font-weight-600'
											htmlFor='input-supporting-document'>
											Supporting Document
										</label>
										{/* <FileUploader
									multiple={true}
									handleChange={handleChange}
									name='supportingDocument'
									types={fileTypes}
									fileOrFiles='Array'
									required
								/>

								{Object.keys(files).length !== 0 ? (
									<>
										<p>Uploaded Files:</p>
										<ul>
											{files.map((file) => (
												<li key={file.name}>
													{file.name}
													<button type='button' onClick={() => handleDelete(file)}>
                            Delete
													</button>
												</li>
											))}
										</ul>
									</>
								) : (
									""
								)} */}
										<input
											type='file'
											accept='image/png, image/jpeg, .pdf'
											className={"form-control " + (errors.supportingDocument ? "is-invalid" : "")}
											id='input-supportingDocument'
											{...register("supportingDocument")}
											multiple
											// required
										/>
										<small>Please upload 1 - 3 files</small>
										<div className='invalid-feedback'>{errors.supportingDocument?.message}</div>
									</FormGroup>
								</Col>

								{message && (
									<Col md='12' xl='12'>
										<div className='form-group'>
											<div
												className='alert alert-danger'
												role='alert'
												dangerouslySetInnerHTML={{ __html: message }}></div>
										</div>
									</Col>
								)}

								<Col md='12' xl='12' className='mt-4'>
									<div className='flex gap-1 justify-content-end'>
										<LightThemedButton Button onClick={() => navigate(-1)}>
											Back
										</LightThemedButton>
										<ThemedButton
											className='btn-gradient'
											type='submit'
											disabled={loading}
											loading={loading}>
											Submit Withdrawal
										</ThemedButton>
									</div>
								</Col>
							</Row>
						</Form>
					</CardBody>
				</Card>
			</div>
		</Container>
	);
}

export default ModalWithdrawal;
